import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';

interface IProps {
  process: any;
  isView: boolean;
  setRender: any;
  operation: any;
}
const OperationSelect = ({ operation, process, isView, setRender }: IProps) => {
  return (
    <>
      {isView ? (
        process.operation_id?.process_name
      ) : (
        <AutocompleteMuiCustom
          id="operation_id"
          label=""
          option_name="process_name"
          arrayofObj={operation}
          value={process.operation_id || ''}
          onChange={(e, value) => {
            process.operation_id = value;
            setRender((prev: any) => !prev);
          }}
        />
      )}
    </>
  );
};

export default OperationSelect;
